import {
  inv01_2025,
  inv02_2025,
  inv03_2025,
  inv04_2025,
  inv05_2025,
  inv06_2025,
  inv07_2025,
  inv08_2025,
  inv_itp_01,
  inv09_2025,
  inv10_2025,
  inv11_2025,
  inv12_2025,
  inv13_2025,
  inv14_2025,
  inv15_2025,
  inv16_2025,
  inv17_2025,
  inv18_2025,
  inv19_2025,
  inv20_2025,
  inv21_2025,
  inv22_2025,
  inv23_2025,
  inv_itp_02,
} from "../../json/anioInvitaciones/2025/anioInvitacion2025";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "CAASIM-HGO-INV3-OP-01-2025":
      datosSeleccionados = inv01_2025;
      break;
    case "CAASIM-HGO-INV3-OP-02-2025":
      datosSeleccionados = inv02_2025;
      break;
    case "CAASIM-HGO-INV3-OP-03-2025":
      datosSeleccionados = inv03_2025;
      break;
    case "CAASIM-HGO-INV3-OP-04-2025":
      datosSeleccionados = inv04_2025;
      break;
    case "CAASIM-HGO-INV3-OP-05-2025":
      datosSeleccionados = inv05_2025;
      break;
    case "CAASIM-HGO-INV3-OP-06-2025":
      datosSeleccionados = inv06_2025;
      break;
    case "CAASIM-HGO-INV3-OP-07-2025":
      datosSeleccionados = inv07_2025;
      break;
    case "CAASIM-HGO-INV3-OP-08-2025":
      datosSeleccionados = inv08_2025;
      break;
    case "ITP-CAASIM-SRMYSG-SAL-01/2025":
      datosSeleccionados = inv_itp_01;
      break;
    case "CAASIM-HGO-INV3-OP-09-2025":
      datosSeleccionados = inv09_2025;
      break;
    case "CAASIM-HGO-INV3-OP-10-2025":
      datosSeleccionados = inv10_2025;
      break;
    case "CAASIM-HGO-INV3-OP-11-2025":
      datosSeleccionados = inv11_2025;
      break;
    case "CAASIM-HGO-INV3-OP-12-2025":
      datosSeleccionados = inv12_2025;
      break;
    case "CAASIM-HGO-INV3-OP-13-2025":
      datosSeleccionados = inv13_2025;
      break;
    case "CAASIM-HGO-INV3-OP-14-2025":
      datosSeleccionados = inv14_2025;
      break;
    case "CAASIM-HGO-INV3-OP-15-2025":
      datosSeleccionados = inv15_2025;
      break;
    case "CAASIM-HGO-INV3-OP-16-2025":
      datosSeleccionados = inv16_2025;
      break;
    case "CAASIM-HGO-INV3-OP-17-2025":
      datosSeleccionados = inv17_2025;
      break;

    case "CAASIM-HGO-INV3-OP-18-2025":
      datosSeleccionados = inv18_2025;
      break;
    case "CAASIM-HGO-INV3-OP-19-2025":
      datosSeleccionados = inv19_2025;
      break;
    case "CAASIM-HGO-INV3-OP-20-2025":
      datosSeleccionados = inv20_2025;
      break;
    case "CAASIM-HGO-INV3-OP-21-2025":
      datosSeleccionados = inv21_2025;
      break;
    case "CAASIM-HGO-INV3-OP-22-2025":
      datosSeleccionados = inv22_2025;
      break;
    case "CAASIM-HGO-INV3-OP-23-2025":
      datosSeleccionados = inv23_2025;
      break;

    case "ITP-CAASIM-SRMYSG-SAL-02/2025":
      datosSeleccionados = inv_itp_02;
      break;

    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
